import { Services as AccountServices } from '@smiles/core-account';
import { IMemberServiceResponse } from '@smiles/core-account/dist/Types/GetMember.types';

export class GetMemberService {
  static async execute(): Promise<IMemberServiceResponse> {
    try {
      const { data, success } = await AccountServices.getMember();

      return { data, success };
    } catch (error) {
      console.error(error);

      return { success: false };
    }
  }
}
